import React from 'react';
import { SUBMISSION_PERIODS } from '../submissions/periodFormat';

export function PISystemInfoTab({
  systemData,
  setSystemData,
  loading,
  onSave,
  onGoToParameters,
  onCancel,
  periodCounts = {},
}) {
  const enabled = systemData.enabled_periods || [];
  const togglePeriod = (p) => {
    const next = enabled.includes(p) ? enabled.filter((x) => x !== p) : [...enabled, p];
    setSystemData({ ...systemData, enabled_periods: next });
  };

  return (
    <form
      className="modal-form"
      onSubmit={(e) => {
        e.preventDefault();
        onSave(systemData);
      }}
      noValidate
    >
      <div className="form-group">
        <label htmlFor="pi-system-info-name">System Name *</label>
        <input
          id="pi-system-info-name"
          type="text"
          required
          value={systemData.name}
          onChange={(e) => setSystemData({ ...systemData, name: e.target.value })}
          maxLength={100}
        />
      </div>
      <div className="form-group">
        <label htmlFor="pi-system-info-version">Version</label>
        <input
          id="pi-system-info-version"
          type="text"
          value={systemData.version}
          onChange={(e) => setSystemData({ ...systemData, version: e.target.value })}
          pattern="^\d+(\.\d+){0,2}$"
          inputMode="decimal"
          title="Numeric only — e.g. 1, 1.0, or 1.0.0"
          aria-describedby="pi-system-info-version-hint"
          maxLength={10}
        />
        <small id="pi-system-info-version-hint">Numeric only — e.g. 1, 1.0, or 1.0.0</small>
      </div>
      <div className="form-group">
        <label htmlFor="pi-system-info-description">Description</label>
        <textarea
          id="pi-system-info-description"
          value={systemData.description}
          onChange={(e) => setSystemData({ ...systemData, description: e.target.value })}
          maxLength={500}
        />
      </div>
      <div className="form-group">
        <label htmlFor="pi-system-info-net-expenses" className="pi-net-expenses-row">
          <span className="pi-net-expenses-name">Include expenses in net deposit</span>
          <input
            id="pi-system-info-net-expenses"
            type="checkbox"
            checked={!!systemData.net_includes_expenses}
            onChange={(e) => setSystemData({ ...systemData, net_includes_expenses: e.target.checked })}
          />
        </label>
      </div>
      <fieldset className="form-group pi-periods">
        <legend>Enabled submission periods</legend>
        {SUBMISSION_PERIODS.map((p) => {
          const checked = enabled.includes(p);
          const removingWithData = !checked ? false : (periodCounts[p] || 0) > 0;
          return (
            <label key={p} htmlFor={`pi-period-${p}`} className="pi-period-row">
              <span className="pi-period-name">{p}</span>
              <input id={`pi-period-${p}`} type="checkbox" checked={checked} onChange={() => togglePeriod(p)} />
              {removingWithData && <span className="pi-period-note">({periodCounts[p]} existing)</span>}
            </label>
          );
        })}
        {enabled.length === 0 && <small role="alert">Select at least one period.</small>}
        {SUBMISSION_PERIODS.some((p) => !enabled.includes(p) && (periodCounts[p] || 0) > 0) && (
          <small className="pi-period-hint">Existing submissions in disabled periods are kept; no new ones can be created.</small>
        )}
      </fieldset>
      <div className="pi-system-actions">
        <button type="submit" className="btn-primary" disabled={loading || enabled.length === 0}>
          Save System Info
        </button>
        <button
          type="button"
          className="btn-secondary"
          onClick={onGoToParameters}
          disabled={loading}
        >
          Go to Parameters →
        </button>
        <button type="button" className="btn-secondary" onClick={onCancel} disabled={loading}>
          Cancel
        </button>
      </div>
    </form>
  );
}
